import { Lightning } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';
import { Recipes, urlWithRecipe } from '../../Business/utility/ImageRecipeUtil';

const _constants = {
  cardWidth: 140,
  radius: 10,
  borderWidth: 5,
};

export class ProfileAvatar extends Lightning.Component {
  static _template() {
    return {
      w: _constants.cardWidth,
      h: _constants.cardWidth,
      ProfileImage: {
        x: 3,
        y: 3,
        w: _constants.cardWidth - 6,
        h: _constants.cardWidth - 6,
      },
      Border: {
        x: 0,
        y: 0,
        w: _constants.cardWidth,
        h: _constants.cardWidth,
        rect: true,
        clip: true,
        visible: false,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: _constants.radius,
          stroke: _constants.borderWidth,
          strokeColor: Theme.Colors.Primary,
          fillColor: Theme.Colors.Transparent,
        },
      },
    };
  }

  _init() {
    this.tag('ProfileImage').src = urlWithRecipe(this.image, Recipes.Profile.Normal);
    this.tag('ProfileImage').on('txError', () => {
      this.tag('ProfileImage').patch({
        rect: true,
        color: Theme.Colors.ProfilePage.InteractionUnfocused,
        ErrorText: {
          mount: 0.5,
          x: w => w / 2,
          y: h => h / 2,
          text: {
            text: 'Error',
            fontSize: 30,
          },
        },
      });
    });
  }

  _focus() {
    this.tag('Border').visible = true;
  }

  _unfocus() {
    this.tag('Border').visible = false;
  }

  set showBorder(bool) {
    this.tag('Border').visible = bool;
  }
}
